import { useMemo } from 'react';

import { useAtom } from 'jotai';
import { cartAtom } from 'state/cart/atoms';

export const useQueryGetShopifyCartOneTimeProductsV2 = () => {
  const [cart, setCart] = useAtom(cartAtom);

  const oneTimeProducts = useMemo(() => {
    if (!cart) {
      return null;
    }

    return cart.lines.filter(
      (item) =>
        !item.sellingPlanAllocation ||
        !item.attributes?.find((attribute) => attribute.key.includes('shop_subscriptions'))
    );
  }, [cart]);

  return {
    oneTimeProducts,
    cart,
    setCart
  };
};
